import type { Editor } from "./canvas";
import type { TLShapeId, TLPageId } from "@tldraw/tlschema";
import type { FilePlacement } from "./file-import-state";
/** Fail rather than silently moving a delayed upload onto a different sheet. */
export function requireImportTarget(editor: Editor, placement: FilePlacement) {
  if (editor.getIsReadonly()) throw new Error("Edit access was removed.");
  if (placement.parentId.startsWith("shape:")) {
    const shape = editor.getShape(placement.parentId as TLShapeId);
    if (!shape || (shape.type !== "sheet" && shape.type !== "trace"))
      throw new Error(
        "The destination sheet was removed. Remove this entry and choose the file at a new destination.",
      );
    if (shape.isLocked || editor.isShapeHidden(shape))
      throw new Error(
        "The destination sheet is locked or hidden. Unlock/show it before resuming.",
      );
  } else if (!editor.getPage(placement.parentId as TLPageId))
    throw new Error("The destination board page was removed.");
  return { ...placement, parentId: placement.parentId as TLShapeId | TLPageId };
}
